import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import VictimCard from 'containers/TransactionManagerTimeLine/VictimInfo/Card';
import RecapDocuments from 'containers/TransactionManagerTimeLine/VictimInfo/RecapDocuments';
import ContactCard from 'containers/TransactionManagerTimeLine/ContactVictim/ContactCard';
import MissionDrawer from 'containers/TransactionManagerTimeLine/ContactVictim/MissionDrawer';
import MissionRecap from 'containers/TransactionManagerTimeLine/ContactVictim/MissionRecap';
import {
  makeSelectMissionsTransaction,
  makeSelectJudiciaryExpertReport,
} from 'containers/TransactionManagerTimeLine/selector';
import { isAssignedArea } from 'containers/TransactionManagerTimeLine/utils';
import { CONTACT_INBOXE_TITLE } from 'containers/TransactionManagerTimeLine/constants';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import {
  VictimType,
  TransactionDocumentType,
  TransactionType,
} from 'typings/globalTypes';

export interface ContactVictimProps {
  intl: IntlShape;
  victim: VictimType;
  listings: any;
  transactionDocuments: TransactionDocumentType[];
  requestAddContactTransaction: Function;
  requestGetContactTransaction: Function;
  contactTransaction: any;
  transactionId: number;
  claimId: number;
  requestUpdateContactTransaction: Function;
  resetStoreTransaction: Function;
  requestGetExpertUsers: Function;
  corporealExperts: any;
  requestAssignedExpert: Function;
  claimNumber: string;
  riskKey: string;
  requestGetMissionTransaction: Function;
  requestUpdateMissionTransaction: Function;
  isConsultation?: boolean;
  expertJudiciaryExpertise: any;
  requestImportMissionExpertise: Function;
  requestGetJudiciaryExpertReport: Function;
  sagisInfo: any;
  transactionInfo: TransactionType;
  lossDate: any;
  requestGetDocByDocumentumId: Function;
  isIntervenant?: boolean;
  requestGetTransaction: Function;
}

const ContactVictim: React.FC<ContactVictimProps> = (props): JSX.Element => {
  const [openDrawerMission, setOpenDrawerMission] = React.useState(false);
  const missionsTransaction = useSelector(makeSelectMissionsTransaction());
  const judiciaryExpertReport = useSelector(makeSelectJudiciaryExpertReport());
  useEffect(() => {
    props.resetStoreTransaction();
    props.requestGetMissionTransaction({
      transactionId: props.transactionId,
      isIntervenant: props.isIntervenant,
    });
    props.requestGetContactTransaction({
      transactionId: props.transactionId,
      isIntervenant: props.isIntervenant,
    });
    props.requestGetJudiciaryExpertReport({
      claimId: props.claimId,
      victimId: get(props.victim, 'id'),
    });
  }, [props.transactionId]);

  const handleToggleDrawer = () => {
    setOpenDrawerMission(false);
  };

  const handleOpenDrawerMission = () => {
    setOpenDrawerMission(true);
  };
  return (
    <>
      <ContactCard
        listings={props.listings}
        contactTransaction={props.contactTransaction}
        transactionId={props.transactionId}
        claimId={props.claimId}
        requestAddContactTransaction={props.requestAddContactTransaction}
        requestUpdateContactTransaction={props.requestUpdateContactTransaction}
        handleOpenDrawerMission={handleOpenDrawerMission}
        isConsultation={
          props.isConsultation ||
          !isAssignedArea(
            props.transactionInfo,
            props.listings,
            CONTACT_INBOXE_TITLE,
          )
        }
        expertJudiciaryExpertise={props.expertJudiciaryExpertise}
        victimId={get(props.victim, 'id') as any}
        requestImportMissionExpertise={props.requestImportMissionExpertise}
        judiciaryExpertReport={judiciaryExpertReport}
        sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
        sagisOpposingParties={extractOpposingParties(
          get(props.sagisInfo, 'offeredRisks', []),
        )}
        victim={props.victim}
        transactionInfo={props.transactionInfo}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
      <VictimCard
        victim={props.victim}
        listings={props.listings}
        isReadOnly={true}
        couldAddBeneficiaries={false}
        lossDate={props.lossDate}
        claimId={props.claimId}
        isConsultation={props.isConsultation}
      />
      <MissionRecap
        missions={missionsTransaction}
        listings={props.listings}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
        corporealExperts={props.corporealExperts}
        requestGetExpertUsers={props.requestGetExpertUsers}
        riskKey={props.riskKey}
        victimId={(get(props.victim, 'id') as unknown) as number}
        transactionId={props.transactionId}
        requestGetMissionTransaction={props.requestGetMissionTransaction}
        requestUpdateMissionTransaction={props.requestUpdateMissionTransaction}
        requestAssignedExpert={props.requestAssignedExpert}
        isConsultation={
          props.isConsultation ||
          !isAssignedArea(
            props.transactionInfo,
            props.listings,
            CONTACT_INBOXE_TITLE,
          )
        }
        lossDate={props.lossDate}
        transactionInfo={props.transactionInfo}
        requestGetTransaction={props.requestGetTransaction}
      />
      <MissionDrawer
        open={openDrawerMission}
        victimId={get(props.victim, 'id')}
        handleToggleDrawer={handleToggleDrawer}
        listings={props.listings}
        requestAssignedExpert={props.requestAssignedExpert}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
        corporealExperts={props.corporealExperts}
        requestGetExpertUsers={props.requestGetExpertUsers}
        riskKey={props.riskKey}
        transactionId={props.transactionId}
        requestGetMissionTransaction={props.requestGetMissionTransaction}
        missionToUpdate={{}}
        transactionInfo={props.transactionInfo}
      />
      <RecapDocuments
        documents={props.transactionDocuments}
        receptionDate={get(props.transactionInfo, 'receptionDate')}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        revenu={get(props.transactionInfo, 'victim.annualOfIncome')}
      />
    </>
  );
};
export default injectIntl(ContactVictim);
